import { useEffect, useState } from 'react';
import { useNostoContext } from '@srcDS/provider/nosto/NostoContext';

import { isEmptyObject } from '@srcDS/utils/assertions';
import { parseProducts } from '@srcDS/js/provider/nosto/utils';
import TagManager from '@srcDS/classes/TagManager';

interface SearchInitialProductsProps {
  placement: string;
  currency: string;
  isSSR: boolean;
  searchPhrase?: string;
}

export const useNostoPlacementProducts = ({ placement, currency, isSSR, searchPhrase }: SearchInitialProductsProps) => {
  const { placementData, hasNostoJs, loading, setPlacements, placements, nostoSearchView } = useNostoContext();
  const [products, setProducts] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (hasNostoJs && !isSSR) {
      nostoSearchView(searchPhrase, placement);
    }

    if (!placements.includes(placement)) {
      setPlacements([...placements, placement]);
    }
    return () => {
      setPlacements([]);
    };
  }, [hasNostoJs, isSSR]);

  useEffect(() => {
    if (!isSSR && hasNostoJs && !loading && !isEmptyObject(placementData) && placementData[placement]) {
      const parsedProducts = parseProducts(placementData[placement]?.products);
      setProducts(parsedProducts);
      setIsLoading(false);
      TagManager.productImpressionsDynamic(parsedProducts, 'Search initial products', currency);
    }

    if(!placement) {
      setIsLoading(false);
    }
  }, [placementData]);

  return { products, isLoading };
};
